import { CheckCircle, RefreshCw, XCircle, Clock } from 'lucide-react';

const getStatusIcon = (status) => {
  switch (status) {
    case 'completed':
      return <CheckCircle className="w-5 h-5 text-green-600" />;
    case 'running':
      return <RefreshCw className="w-5 h-5 text-primary animate-spin" />;
    case 'failed':
      return <XCircle className="w-5 h-5 text-red-600" />;
    case 'awaiting_approval':
    case 'paused':
      return <Clock className="w-5 h-5 text-yellow-600" />;
    default:
      return <Clock className="w-5 h-5 text-gray-600" />;
  }
};

const OrchestrationList = ({ orchestrations, onSelect }) => {
  if (!orchestrations || orchestrations.length === 0) return null;

  return (
    <div className="bg-white rounded-lg shadow-md p-6 mt-8">
      <h2 className="text-xl font-semibold mb-4">Recent Orchestrations</h2>
      <div className="space-y-2">
        {orchestrations.map((orc) => (
          <div
            key={orc.id}
            className="p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            onClick={() => onSelect(orc.id)}
          >
            <div className="flex items-center justify-between">
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate text-gray-900">{orc.user_goal}</div>
                <div className="text-sm text-gray-500 mt-0.5">
                  Created: {new Date(orc.created_at).toLocaleString()}
                </div>
              </div>
              <div className="flex items-center gap-2 ml-4 shrink-0">
                {getStatusIcon(orc.status)}
                <span className="text-sm text-gray-600">{orc.status}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrchestrationList;
